import { FeedbackNotFoundError, type FeedbackDetail, type FeedbackReply } from '@/shared/domain'
import { type HttpGet, mapServerError } from '@/shared/infra/http'
import type { GetFeedbackDetail } from '@/modules/feedback/use-cases'
import { toFeedback, type FeedbackRowWire } from './supabase-list-user-feedback-repository'

type ReplyWire = {
  id?: string | null
  feedbackId?: string | null
  body?: string | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}

type DetailWire = {
  feedback?: FeedbackRowWire | null
  replies?: ReplyWire[] | null
}

function toReply(wire: ReplyWire): FeedbackReply {
  return {
    id: wire.id ?? '',
    feedbackId: wire.feedbackId ?? '',
    body: wire.body ?? '',
    createdBy: wire.createdBy ?? '',
    createdAt: wire.createdAt ?? '',
    updatedAt: wire.updatedAt ?? '',
  }
}

export class SupabaseGetFeedbackDetailRepository {
  constructor(private readonly http: HttpGet) {}

  execute: GetFeedbackDetail = async ({ feedbackId }): Promise<FeedbackDetail> => {
    try {
      const response = await this.http.get<DetailWire>({ url: `/feedback/${feedbackId}` })
      return {
        feedback: toFeedback(response?.feedback ?? {}),
        replies: (response?.replies ?? []).map(toReply),
      }
    } catch (err) {
      mapServerError(err, { '404': FeedbackNotFoundError })
    }
  }
}
